import { CityMaintenanceSaveRequest } from './../pages/city-maintenance/interface/city-maintenance-save-request';
import { CityMaintenanceGetRequest } from './../pages/city-maintenance/interface/city-maintenance-get-request';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CityMaintenanceGetResponse } from '../pages/city-maintenance/interface/city-maintenance-get-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CityMaintenanceService {

  private baseUrl: string = `${environment.logisticsApiUrl}/city/maintenance`
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(
    private http: HttpClient
  ) { }

  getCity(request: CityMaintenanceGetRequest): Observable<CityMaintenanceGetResponse> {
    return this.http.post<CityMaintenanceGetResponse>(this.baseUrl, request, this.httpOptions);
  }

  saveCityChanges(request: CityMaintenanceSaveRequest): Observable<void> {
    return this.http.put<void>(this.baseUrl, request, this.httpOptions);
  }
}
